import { message } from 'antd';
export const onClickCopy = async (
  value: string | number,
  maskValue?: string
): Promise<void> => {
  const displayValue = maskValue ? maskValue : `"${value}"`;
  try {
    await navigator.clipboard.writeText(String(value));
    void message.success(`${displayValue} copied to clipboard.`);
  } catch (err) {
    void message.error(`Failed to copy value "${displayValue}"`);
  }
};
